import { Check } from 'lucide-react';
import { useDocxBuilder, type BuilderStep } from './context';

const STEPS = ['Upload', 'Mark fields', 'Publish'] as const;

export function DocxBuilderStepper() {
  const { step, docx, setStep, setReplacing } = useDocxBuilder();

  const canNavigateTo = (n: BuilderStep): boolean => {
    if (n === 1) return true;
    return !!docx;
  };

  const handleClick = (n: BuilderStep) => {
    if (!canNavigateTo(n) || n === step) return;
    if (n !== 1) setReplacing(false);
    setStep(n);
  };

  return (
    <ol className="flex items-center gap-2" aria-label="Builder steps">
      {STEPS.map((label, i) => {
        const n = (i + 1) as BuilderStep;
        const state: 'done' | 'active' | 'todo' =
          n < step ? 'done' : n === step ? 'active' : 'todo';
        const clickable = canNavigateTo(n) && n !== step;

        return (
          <li key={label} className="flex items-center gap-2 min-w-0">
            <button
              type="button"
              onClick={() => handleClick(n)}
              disabled={!clickable}
              className={`group flex items-center gap-2 min-w-0 disabled:cursor-default ${clickable ? 'cursor-pointer' : ''}`}
            >
              <span
                aria-current={state === 'active' ? 'step' : undefined}
                className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-medium transition-colors ${
                  state === 'done'
                    ? 'bg-selise-blue text-white group-hover:bg-selise-blue/80'
                    : state === 'active'
                    ? 'bg-selise-blue/15 text-selise-blue ring-2 ring-selise-blue/40'
                    : 'bg-muted text-globe-grey group-hover:ring-2 group-hover:ring-selise-blue/40'
                }`}
              >
                {state === 'done' ? <Check className="h-3.5 w-3.5" /> : n}
              </span>
              <span
                className={`hidden sm:inline text-sm truncate ${
                  state === 'todo' ? 'text-globe-grey' : 'text-[hsl(var(--fg))] font-medium'
                } ${clickable ? 'group-hover:text-selise-blue' : ''}`}
              >
                {label}
              </span>
            </button>
            {i < STEPS.length - 1 && (
              <span className="mx-1 h-px w-6 shrink-0 bg-border" aria-hidden />
            )}
          </li>
        );
      })}
    </ol>
  );
}
